import React from "react";

export default function SensorInfoSlide({ project, slideIndex, totalSlides, progressPct, onGoTo }) {
  // Extract area name from project data (use first area if available)
  const areaName = project?.areas?.[0]?.name || "Schlosspark Nymphenburg";
  const locationName = areaName.includes("MGS")
    ? areaName.replace("MGS ", "")
    : `${areaName} · München`;

  return (
    <div className="dv3-slide dv3-slide--info">
      <div className="dv3-slide__header">
        <div className="dv2-sensor-badge dv2-sensor-badge--soil">
          <span className="dv2-s-dot" />
          TreeSense · Live-Monitoring
        </div>
        <div className="dv2-nav-dots">
          {Array.from({ length: totalSlides }).map((_, i) => (
            <button
              key={i}
              type="button"
              className={`dv2-nd ${i === slideIndex ? "dv2-nd--on" : ""}`}
              onClick={() => onGoTo(i)}
              aria-label={`Folie ${i + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="dv3-slide__title-row">
        <div className="dv3-slide__tree-name">Unsere Bäume sprechen mit uns.</div>
        <div className="dv3-slide__tree-species">{locationName}</div>
      </div>

      <div className="dv3-info-slide">
        <div className="dv3-info-section">
          <div className="dv3-info-section__label">TreeSense Pulse</div>
          <p className="dv3-info-section__text">
            Sensoren in den Bäumen messen die Feuchtigkeit in Echtzeit. So wissen die Gärtner genau,
            wann ein Baum Wasser braucht – kein Rätselraten mehr. Der TreeSense Pulse bietet direkte
            Einblicke in den Wasserhaushalt der Pflanze, indem er den elektrischen Widerstand in der
            wasserführenden Schicht misst. TreeSense kombiniert diese Daten, um einen
            Feuchtigkeitsindex zu berechnen, der als präzises Monitoring-Tool für den Wasserhaushalt
            der Pflanze dient.
          </p>
        </div>

        <div className="dv3-info-section">
          <div className="dv3-info-section__label">Wussten Sie schon?</div>
          <div className="dv3-info-facts">
            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/sun.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Bis zu 8 °C kühler</div>
                <div className="dv3-info-fact__desc">
                  Ein einziger Baum kühlt seine Umgebung um bis zu 8 Grad – wie eine natürliche
                  Klimaanlage.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/watering.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">70 % weniger Wasserverbrauch</div>
                <div className="dv3-info-fact__desc">
                  Datengestützte Bewässerung spart gegenüber Pauschalbewässerung bis zu 70 % Wasser.
                </div>
              </div>
            </div>

            <div className="dv3-info-fact">
              <div className="dv3-info-fact__icon">
                <img src="/img/weather/trees-leaves.png" alt="" aria-hidden="true" />
              </div>
              <div className="dv3-info-fact__body">
                <div className="dv3-info-fact__title">Heimat für Insekten</div>
                <div className="dv3-info-fact__desc">
                  Stadtbäume bieten Lebensraum für Bienen, Hummeln und Schmetterlinge.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dv2-prog-bar" style={{ width: `${progressPct}%` }} />
    </div>
  );
}
